












































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import { ORDER_STATUS_DICT } from '@/web-task/config.ts'
import {
	FIRST_VISIT,
	RESURVEY,
	MOTION,
	NEW_MOTION,
	OTHER_INVEST,
} from '@/utils/const'

@Component({})
export default class ActionCol extends Vue {
	private YI_QU_XIAO = ORDER_STATUS_DICT.YI_QU_XIAO
	private YI_GUAN_DAN = ORDER_STATUS_DICT.YI_GUAN_DAN
	private FIRST_VISIT = FIRST_VISIT
	private RESURVEY = RESURVEY
	private MOTION = MOTION
	private NEW_MOTION = NEW_MOTION
	private OTHER_INVEST = OTHER_INVEST

	@Prop({})
	private row!: any

	@Prop({})
	// 公用列表操作列组件 用于区分不同页面的操作项权限
	private authObj!: any

	private goToAiiTaskDetail(row: any) {
		return `/AiiTasks/TasksDetail/${row.orderId}/${row.taskType}`
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId)
					.then((res: any) => {
						this.$message.success('发送成功')
						this.$emit('resendSucCb')
					})
					.catch(err => {
						console.error('resend failed: ', err)
					})
			},
		})
	}
}
